// extracted by mini-css-extract-plugin
export default {"base":"SearchOverview_base__O5gFQ","item":"SearchOverview_item__fTBCs","label":"SearchOverview_label__6B0ro"};